module.exports = __webpack_public_path__ + "img/gongnuan.bca332e2.jpg";